'use client';
import { DesignSystemError } from './DesignSystemError.js';

class CompoundRootRequiredError extends DesignSystemError {
    constructor(packageName, componentName, info){
        super(packageName, `Компонент ${componentName} не найден в дереве`, info);
        Object.setPrototypeOf(this, CompoundRootRequiredError.prototype);
    }
}

export { CompoundRootRequiredError };
//# sourceMappingURL=CompoundRootRequiredError.js.map
